<template>
  <v-row>
    <v-col cols="12" lg="7" xl="6" class="background-login d-none d-md-flex align-center justify-center">
      <!--<v-container>
        <div class="pa-10">
          <v-row justify="center">
            <v-col cols="8" xl="5"></v-col>
          </v-row>
        </div>
      </v-container>-->
      <!--<img width="100" src="@/assets/images/background/bg-login.jpg" />-->
    </v-col>
    <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
      <v-container>
        <div class="pa-7 pa-sm-12">
          <v-row class="justify-center">
            <v-col cols="12" lg="12" xl="6">
              <div style="text-align:center">
                <div style="max-height:100px !important" class="mt-6">
                  <img width="100" src="@/assets/images/logo-agrovision.svg" />
                </div>
              </div>
              <v-form ref="form" v-model="valid" lazy-validation action="/">
                <v-text-field
                  v-model="usuario"
                  :rules="usuarioRules"
                  label="Usuario"
                  class="mt-4"
                  required
                  outlined
                  uppercase
                  prepend-inner-icon="fas fa-id-badge"
                  @blur="upperCase"
                >
                </v-text-field>
                <v-text-field
                  v-model="clave"
                  :rules="claveRules"
                  label="Contraseña"
                  required
                  outlined
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-select
                  :items="data"
                  v-model="empresa"
                  :rules="empresaRules"
                  label="Empresa"
                  outlined
                  required
                  prepend-inner-icon="fas fa-building"
                ></v-select>
                <v-btn :disabled="!valid" color="info" block class="mr-4" submit @click="submit">Iniciar Sesión</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import LoginService from '../services/LoginService';
import Swal from 'sweetalert2';
export default {
  name: 'Login',
  data: () => ({
    loginService: null,
    valid: true,
    clave: '',
    empresa: '',
    show1: false,
    usuario: '',
    claveRules: [(v) => !!v || 'Contraseña es requerida.'],
    usuarioRules: [(v) => !!v || 'Usuario es requerido.'],
    empresaRules: [(v) => !!v || 'Empresa es requerida'],
    checkbox: false,
    data: []
  }),
  methods: {
    upperCase() {
      this.usuario = this.usuario.toUpperCase();
    },
    async iniciaData() {
      const res = await this.loginService.get().execResource('empresas', {
        api_token: 'BBBBBBBBBBB*cXXVOkdQgiJBJBBCKF'
      });
      res.forEach((element) => {
        this.data.push({ text: element.razonsocial, value: element.idempresa });
      });
    },
    async submit() {
      this.$refs.form.validate();
      if (this.$refs.form.validate(true)) {
        const res = await this.loginService.post().execResource('login', {
          usuario: this.usuario,
          clave: this.clave
        });

        if (!res.status) {
          await Swal.fire({
            icon: 'error',
            title: res.message,
            confirmButtonText: `OK`
          });
          return;
        }
        if (parseInt(res.data.user.dias) <= 15) {
          if (res.data.user.dias <= 0) {
            await Swal.fire({
              icon: 'error',
              title: `Su licencia ha vencido, no cuenta con acceso al sistema...`,
              confirmButtonText: `OK`
            });
            return;
          }
          await Swal.fire({
            icon: 'warning',
            title: `Quedan ${res.data.user.dias} dias de prueba...`,
            confirmButtonText: `OK`
          });
        }
        await this.setLocal(res);
        this.$router.push({ path: '/campamento/dashboard' });
      }
    },
    async setLocal(res) {
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('emp', this.empresa);
      localStorage.setItem('user', this.usuario);
      localStorage.setItem('password', this.clave);
    }
  },
  created() {
    this.usuario = localStorage.getItem('user');
    this.clave = localStorage.getItem('password');
    this.empresa = localStorage.getItem('emp');
  },
  async mounted() {
    if (localStorage.getItem('token') != undefined) {
      this.$router.push({ path: '/campamento/dashboard' });
    } else {
      this.loginService = this.$httpService(new LoginService(), this);
      await this.iniciaData();
    }
  }
};
</script>
<style lang="css">
.background-login {
  background: url('../../../assets/images/background/bg-login.jpg') no-repeat;
  background-size: cover;
  /*background: url('../../../assets/images/background/bg-login.jpg') no-repeat fixed center;*/
  /*background-size: contain;*/
  /* background-position: initial;*/
}
</style>
